<template>
  <div>
    <div class="title">
      <h2>北管音樂團體基礎概況調查分析<sup>1</sup></h2>
      <span>文/林雅琇</span>
    </div>
    <hr />
    <p class="firstRow"></p>
<h3>壹、前言</h3>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;應國立傳統藝術中心之委託，「2022臺灣音樂年鑑編輯計畫」北管音樂子領域今年另執行北管團體之問卷調查，研究團隊根據2021年之團體名錄為基礎，進行問卷填寫意願之探詢。今年度觀察之北管團體共可分為幾類：具文資身分之團體（中央及地方）及不具文資身分之子弟團、職業團體等。其中，隨著時代之演進與順應社會之潮流/生存模式，不具文資身分之子弟團，又因其活動目的或經費補助，而有1.維持日常自主練習的子弟曲館、2.僅在所屬宮廟活動才聚集排場或請職業團以該團名號出門者，3.會兼當職業團接Case出陣的半職業/子弟曲館，以及4.由政府資助、協助已散館或瀕臨散館之曲館開設北管研習班招收新生，惟因此類新生已與早期所認知之「子弟」相去甚遠，更多的是一種參與社區推廣班的概念，因此筆者將他獨立一類。至於劇團部分，則多為職業劇團，因此也歸屬於前述職業團體一類。</p>
<h3>貳、團體數量</h3>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本次問卷發放採電子檔、紙本並行，研究團隊徵詢118個團體之填寫意願後，共計發出86份，回收45份，回收率52%。問卷內容共分為基本資料、2022年活動與收支情況、人力結構與當前面臨問題等四個層面，共計19大題（合計29小題），題目形式包含單選、複選、問答題的結構式問卷。以下統計分析內容，為求行文之流暢，以下統計分析內容中所稱之「北管團體」概指填寫問卷之北管團體，是故全文中所指之「總數」，即指所收到之問卷總數45份。</p>

<span>2022「北管音樂團體基礎概況調查表」問卷團體（依筆劃排序）</span>
<table rules="all" border="1" style="border: 1px solid" cellpadding="5" >
<tbody>
<tr>
<td colspan="3" width="553">
<p>團體名稱</p>
</td>
</tr>
<tr>
<td width="184">
<p>三芝協和軒</p>
</td>
<td width="185">
<p>三重清樂音</p>
</td>
<td width="185">
<p>大甲鎮瀾宮開路鼓、轎前吹</p>
</td>
</tr>
<tr>
<td width="184">
<p>中華民國傳統民俗文化協會</p>
</td>
<td width="185">
<p>北投新樂社</p>
</td>
<td width="185">
<p>北威聲奏樂團</p>
</td>
</tr>
<tr>
<td width="184">
<p>台中勝樂軒</p>
</td>
<td width="185">
<p>台北共樂軒</p>
</td>
<td width="185">
<p>台北和華樂社</p>
</td>
</tr>
<tr>
<td width="184">
<p>台北碧樂社</p>
</td>
<td width="185">
<p>台北雙連社</p>
</td>
<td width="185">
<p>台北靈安社</p>
</td>
</tr>
<tr>
<td width="184">
<p>台南前甲正和軒民俗古樂團</p>
</td>
<td width="185">
<p>同興北管社</p>
</td>
<td width="185">
<p>汐止樂英社</p>
</td>
</tr>
<tr>
<td width="184">
<p>竹塹北管藝術團</p>
</td>
<td width="185">
<p>宜蘭暨集堂</p>
</td>
<td width="185">
<p>屈尺國興社</p>
</td>
</tr>
<tr>
<td width="184">
<p>東山鳳梨園</p>
</td>
<td width="185">
<p>東門集樂軒</p>
</td>
<td width="185">
<p>東港東隆宮大漢樂團</p>
</td>
</tr>
<tr>
<td width="184">
<p>板橋福安社</p>
</td>
<td width="185">
<p>板橋聚安社</p>
</td>
<td width="185">
<p>板橋潮和社</p>
</td>
</tr>
<tr>
<td width="184">
<p>林口樂林園</p>
</td>
<td width="185">
<p>林口顯林社</p>
</td>
<td width="185">
<p>南屯景樂軒</p>
</td>
</tr>
<tr>
<td width="184">
<p>桃園同芯社</p>
</td>
<td width="185">
<p>財團法人台北保安宮北管社</p>
</td>
<td width="185">
<p>基隆三坑得意堂</p>
</td>
</tr>
<tr>
<td width="184">
<p>基隆得意堂十組文化協會</p>
</td>
<td width="185">
<p>基隆聚樂社一組</p>
</td>
<td width="185">
<p>梨芳園北管樂團</p>
</td>
</tr>
<tr>
<td width="184">
<p>淡水南北軒</p>
</td>
<td width="185">
<p>菁桐南極社</p>
</td>
<td width="185">
<p>新港舞鳳軒</p>
</td>
</tr>
<tr>
<td width="184">
<p>嘉義中林金樂軒</p>
</td>
<td width="185">
<p>彰化花壇御夆閣亂彈劇團</p>
</td>
<td width="185">
<p>彰化梨春園北管樂團</p>
</td>
</tr>
<tr>
<td width="184">
<p>彰化鳳儀園北管樂團</p>
</td>
<td width="185">
<p>榮樂軒北管劇團</p>
</td>
<td width="185">
<p>翠蘭戲曲工作坊</p>
</td>
</tr>
<tr>
<td width="184">
<p>學甲慈濟宮漢聲軒</p>
</td>
<td width="185">
<p>蘆洲樂樂樂</p>
</td>
<td width="185">
<p>㩳愉轃北管掌中實驗團</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;就本次問卷回覆收集結果，共有來自臺灣本島四區<sup>2</sup>的北管團體填寫，其中以北部地區填寫數量為最多，佔總數58%，填寫問卷之團體所在地區分布比例詳如下表、下圖所示。</p>
<p></p>
<table>
<tbody>
<tr style="vertical-align: top;">
<td width="170">
<span>表1：北管團體所在區域統計</span>
<table rules="all" border="1" style="border: 1px solid" cellpadding="5">
<tbody>
<tr >
<td width="56">
<p>地區</p>
</td>
<td width="57">
<p>數量</p>
</td>
</tr>
<tr>
<td width="56">
<p>北部</p>
</td>
<td width="57">
<p>26</p>
</td>
</tr>
<tr>
<td width="56">
<p>中部</p>
</td>
<td width="57">
<p>11</p>
</td>
</tr>
<tr>
<td width="56">
<p>南部</p>
</td>
<td width="57">
<p>7</p>
</td>
</tr>
<tr>
<td width="56">
<p>東部</p>
</td>
<td width="57">
<p>1</p>
</td>
</tr>
<tr>
<td width="56">
<p>小計</p>
</td>
<td width="57">
<p>45</p>
</td>
</tr>
</tbody>
</table>
</td>
<td v-if="!isMobile" class="tableCenter">
  <img class="img60" src="./../../../assets/ob17/1.jpg" alt="" />

<p>圖1：北管團體所在區域比例</p>
</td>
</tr>
<tr v-if="isMobile">
  <td  class="tableCenter">
  <img class="img60" src="./../../../assets/ob17/1.jpg" alt="" />

<p>圖1：北管團體所在區域比例</p>
</td>
</tr>
</tbody>
</table>
<p></p>
<p>北管團體的<strong>成立時間</strong>部分，筆者粗略劃分為8個時間段，所獲資訊如下圖所示，另有7個團體未作答，作答率84%。</p>
<table>
<tbody>
<tr style="vertical-align: top;">
<td width="151">
<p>表2：北管團體成立時間統計</p>
<table rules="all" border="1" style="border: 1px solid" cellpadding="5" width="137">
<tbody>
<tr >
<td width="81">
<p>成立時間</p>
</td>
<td width="57">
<p>數量</p>
</td>
</tr>
<tr>
<td width="81">
<p>1911前</p>
</td>
<td width="57">
<p>10</p>
</td>
</tr>
<tr>
<td width="81">
<p>1911-1948</p>
</td>
<td width="57">
<p>10</p>
</td>
</tr>
<tr>
<td width="81">
<p>1948-1969</p>
</td>
<td width="57">
<p>2</p>
</td>
</tr>
<tr>
<td width="81">
<p>1970-1979</p>
</td>
<td width="57">
<p>1</p>
</td>
</tr>
<tr>
<td width="81">
<p>1980-1989</p>
</td>
<td width="57">
<p>3</p>
</td>
</tr>
<tr>
<td width="81">
<p>1990-1999</p>
</td>
<td width="57">
<p>2</p>
</td>
</tr>
<tr>
<td width="81">
<p>2000-2009</p>
</td>
<td width="57">
<p>3</p>
</td>
</tr>
<tr>
<td width="81">
<p>2010-</p>
</td>
<td width="57">
<p>7</p>
</td>
</tr>
<tr>
<td width="81">
<p>未填寫</p>
</td>
<td width="57">
<p>7</p>
</td>
</tr>
<tr>
<td width="81">
<p>小計</p>
</td>
<td width="57">
<p>45</p>
</td>
</tr>
</tbody>
</table>
</td>
<td v-if="!isMobile" class="tableCenter">
  <img class="img60" src="./../../../assets/ob17/2.jpg" alt="" />
<p>圖2：北管團體成立時間比例</p>
</td>
</tr>
<tr v-if="isMobile">
  <td  class="tableCenter">
  <img class="img60" src="./../../../assets/ob17/2.jpg" alt="" />

<p>圖2：北管團體成立時間比例</p>
</td>
</tr>
</tbody>
</table>
<p></p>
<table cellpadding="5">
  <tbody>
    <tr>
      <td class="tableCenter">
        <img class="img55" src="./../../../assets/ob17/3.jpg" alt="" />
      </td>
    </tr>
    <tr>
      <td class="tableCenter">
        <p style="width:50%;margin:0 auto;" class="tableCenter">圖3：北管團體成立時間分析</p>
      </td>
    </tr>
  </tbody>
</table>
<p></p>
<h1>參、立案情形</h1>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;立案情形部分，45個團體中，共有32個團體已立案，佔總數71%，未立案團體10個，另有3個團體未作答，作答率93%。其中，在已立案團體之主管機關部分，9成皆隸屬於文化部文化資產局或縣市文化局之管轄，僅有3個團體屬於內政部或縣市社會局主管。團隊榮譽的部分，45個團體中，計有12個團體具有國家級指定或地方縣市文化局登錄之傳統表演藝術保存團體，佔總數之26％。另外有2個團體雖尚未登錄為保存團體，但已是地方文化局列冊追蹤之對象；以及有1個團體為地方扶植之演藝團隊。</p>
<table cellpadding="5">
  <tbody>
    <tr>
      <td class="tableCenter">
        <img class="img55" src="./../../../assets/ob17/4.jpg" alt="" />
      </td>
    </tr>
    <tr>
      <td class="tableCenter">
        <p style="width:50%;margin:0 auto;" class="tableCenter">圖4：北管團體立案情形分析</p>
      </td>
    </tr>
  </tbody>
</table>
<p></p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;聯絡方式部分，根據調查結果，共有82%之北管團體有Facebook粉絲專頁，並以此作為聯絡與傳播管道。</p>
<span>表3：北管團體使用Facebook數量統計</span>
<table rules="all" border="1" style="border: 1px solid" cellpadding="5">
<tbody>
<tr>
<td width="64">
<p>有/無</p>
</td>
<td width="57">
<p>數量</p>
</td>
</tr>
<tr>
<td width="64">
<p>有</p>
</td>
<td width="57">
<p>37</p>
</td>
</tr>
<tr>
<td width="64">
<p>無</p>
</td>
<td width="57">
<p>2</p>
</td>
</tr>
<tr>
<td width="64">
<p>未填寫</p>
</td>
<td width="57">
<p>6</p>
</td>
</tr>
<tr>
<td width="64">
<p>小計</p>
</td>
<td width="57">
<p>45</p>
</td>
</tr>
</tbody>
</table>
<table cellpadding="5">
  <tbody>
    <tr>
      <td class="tableCenter">
        <img class="img55" src="./../../../assets/ob17/5.jpg" alt="" />
      </td>
    </tr>
    <tr>
      <td class="tableCenter">
        <p style="width:50%;margin:0 auto;" class="tableCenter">圖5：北管團體使用Facebook比例</p>
      </td>
    </tr>
  </tbody>
</table>
<p></p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;綜上所述，從所獲得之問卷回應中，可以看到北管團體以北部與中部較為活躍；現存之北管團體，有將近五成為清代至日治時期成立，歷史極為悠久。而隨著時代的推移，北管團體也相繼登記立案，部分史料保存較為完善、較具規模的曲館，也陸續獲得地方或中央認定之傳統表演藝術保存團體。又，因應時代潮流，逾八成之北管團體皆以網路社群媒體作為新時代的傳播媒介。</p>
<h3>肆、營運模式</h3>
<strong>一、收支情況</strong>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;收入部分，六成五的北管團體年收入為50萬以下，年收入50萬以上者，僅有20%，另有6個團體未回答，回應率86％。至於收入來源部分，本問卷共分為政府補助、公部門活動演出費、民間活動演出費、票房收入、民間贊助、教學活動、自籌經費、其他等8類。經過分析，北管團體以自籌經費及民間活動演出費為主要來源，政府補助及公部門活動演出費次之，票房收入則無。</p>
<table>
<tbody>
<tr style="vertical-align: top;">
<td width="161">
<p>表4：北管團體年收入統計</p>
<table rules="all" border="1" style="border: 1px solid" cellpadding="5" >
<tbody>
<tr>
<td width="87">
<p>收入狀況</p>
</td>
<td width="57">
<p>數量</p>
</td>
</tr>
<tr>
<td width="87">
<p>25萬以下</p>
</td>
<td width="57">
<p>18</p>
</td>
</tr>
<tr>
<td width="87">
<p>26-50萬</p>
</td>
<td width="57">
<p>11</p>
</td>
</tr>
<tr>
<td width="87">
<p>51-75萬</p>
</td>
<td width="57">
<p>5</p>
</td>
</tr>
<tr>
<td width="87">
<p>76-100萬</p>
</td>
<td width="57">
<p>1</p>
</td>
</tr>
<tr>
<td width="87">
<p>100萬以上</p>
</td>
<td width="57">
<p>3</p>
</td>
</tr>
<tr>
<td width="87">
<p>其他</p>
</td>
<td width="57">
<p>1</p>
</td>
</tr>
<tr>
<td width="87">
<p>未填寫</p>
</td>
<td width="57">
<p>6</p>
</td>
</tr>
<tr>
<td width="87">
<p>小計</p>
</td>
<td width="57">
<p>45</p>
</td>
</tr>
</tbody>
</table>
</td>
  <td v-if="!isMobile" class="tableCenter">
  <img class="img60" src="./../../../assets/ob17/6.jpg" alt="" />
<p>圖6：北管團體年收入比例</p>
</td>
</tr>
<tr v-if="isMobile">
  <td  class="tableCenter">
  <img class="img60" src="./../../../assets/ob17/6.jpg" alt="" />

<p>圖6：北管團體年收入比例</p>
</td>
</tr>
</tbody>
</table>
<p></p>
<table cellpadding="5">
  <tbody>
    <tr>
      <td class="tableCenter">
        <img class="img55" src="./../../../assets/ob17/7.jpeg" alt="" />
      </td>
    </tr>
    <tr>
      <td class="tableCenter">
        <p style="width:50%;margin:0 auto;" class="tableCenter">圖7：北管團體年收入類型統計</p>
      </td>
    </tr>
  </tbody>
</table>
<p></p>
<table cellpadding="5">
  <tbody>
    <tr>
      <td class="tableCenter">
        <img class="img55" src="./../../../assets/ob17/8.jpg" alt="" />
      </td>
    </tr>
    <tr>
      <td class="tableCenter">
        <p style="width:50%;margin:0 auto;" class="tableCenter">圖8：北管團體年收入類型比例</p>
      </td>
    </tr>
  </tbody>
</table>
<p></p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;支出部分，六成的北管團體年支出為50萬以下，而年支出50萬以上者，僅有20%，另有7個團體未回答，回應率84％。至於曲館的花費流向，本問卷共分為同好切磋（拜館交流、排場）、民間傳統廟會及祭典、音樂廳演出支出、教學與推廣研習、館舍維護、專任人事支出及其他等七類，經過分析，北管團體的主要支出為民間傳統廟會及祭典、館舍維護，教學與推廣研習、同好切磋及其他類次之。此部分的其他一類，筆者綜合歸納為房租支出、樂器及文物的維護與購置、樂手薪資以及聚餐交誼等。</p>
<table>
<tbody>
  <tr style="vertical-align: top;">
<td width="161">
<p>表5：北管團體年支出統計</p>
<table rules="all" border="1" style="border: 1px solid" cellpadding="5">
<tbody>
<tr>
<td width="87">
<p>支出狀況</p>
</td>
<td width="57">
<p>數量</p>
</td>
</tr>
<tr>
<td width="87">
<p>25萬以下</p>
</td>
<td width="57">
<p>14</p>
</td>
</tr>
<tr>
<td width="87">
<p>26-50萬</p>
</td>
<td width="57">
<p>13</p>
</td>
</tr>
<tr>
<td width="87">
<p>51-75萬</p>
</td>
<td width="57">
<p>3</p>
</td>
</tr>
<tr>
<td width="87">
<p>76-100萬</p>
</td>
<td width="57">
<p>1</p>
</td>
</tr>
<tr>
<td width="87">
<p>100萬以上</p>
</td>
<td width="57">
<p>5</p>
</td>
</tr>
<tr>
<td width="87">
<p>其他</p>
</td>
<td width="57">
<p>2</p>
</td>
</tr>
<tr>
<td width="87">
<p>未填寫</p>
</td>
<td width="57">
<p>7</p>
</td>
</tr>
<tr>
<td width="87">
<p>小計</p>
</td>
<td width="57">
<p>45</p>
</td>
</tr>
</tbody>
</table>
</td>

<td  v-if="!isMobile" class="tableCenter">
  <img class="img60" src="./../../../assets/ob17/9.jpg" alt="" />
<p>圖9：北管團體年支出比例</p>
</td>
</tr>
<tr v-if="isMobile">
  <td  class="tableCenter">
  <img class="img60" src="./../../../assets/ob17/9.jpg" alt="" />

<p>圖9：北管團體年支出比例</p>
</td>
</tr>
</tbody>
</table>
<p></p>
<table cellpadding="5">
  <tbody>
    <tr>
      <td class="tableCenter">
        <img class="img55" src="./../../../assets/ob17/10.jpeg" alt="" />
      </td>
    </tr>
    <tr>
      <td class="tableCenter">
        <p style="width:50%;margin:0 auto;" class="tableCenter">圖10：北管團體年支出類型統計</p>
      </td>
    </tr>
  </tbody>
</table>
<p></p>
<table cellpadding="5">
  <tbody>
    <tr>
      <td class="tableCenter">
        <img class="img55" src="./../../../assets/ob17/11.jpg" alt="" />
      </td>
    </tr>
    <tr>
      <td class="tableCenter">
        <p class="tableCenter">圖11：北管團體年支出類型比例</p>
      </td>
    </tr>
  </tbody>
</table>
<p></p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;若將團體回應之收入與支出情況比對其損益平衡情況，逾半數的團體都在不同的金額區間中，勉為其難地維持收支平衡<sup>3</sup>，具有盈餘者僅6％、虧損者則佔18％。</p>
<table>
<tbody>
  <tr style="vertical-align: top;">
<td width="161">
<p>表6：北管團體收支關係統計</p>
<table rules="all" border="1" style="border: 1px solid" cellpadding="5">
<tbody>
<tr>
<td width="87">
<p>盈虧情形</p>
</td>
<td width="57">
<p>數量</p>
</td>
</tr>
<tr>
<td width="87">
<p>盈餘</p>
</td>
<td width="57">
<p>3</p>
</td>
</tr>
<tr>
<td width="87">
<p>虧損</p>
</td>
<td width="57">
<p>8</p>
</td>
</tr>
<tr>
<td width="87">
<p>平衡</p>
</td>
<td width="57">
<p>26</p>
</td>
</tr>
<tr>
<td width="87">
<p>無法判定</p>
</td>
<td width="57">
<p>8</p>
</td>
</tr>
<tr>
<td width="87">
<p>小計</p>
</td>
<td width="57">
<p>45</p>
</td>
</tr>
</tbody>
</table>
</td>

<td v-if="!isMobile" class="tableCenter">
  <img class="img60" src="./../../../assets/ob17/12.jpg" alt="" />
<p>圖12：北管團體收支關係比例</p>
</td>
</tr>
<tr v-if="isMobile">
  <td  class="tableCenter">
  <img class="img60" src="./../../../assets/ob17/12.jpg" alt="" />

<p>圖12：北管團體收支關係比例</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;綜上所述，從所獲得之問卷回應中，可以見到團體之經營相當不易，也再一次驗證北管團體大部分都是自娛自樂、服祀神明及地方所屬宮廟之業餘團體；且因這樣子的地緣性質主導，因此年演出場次並不多，收支多為平衡或略有虧損的狀態。</p>
<h3>伍、2022年活動概況</h3>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;根據問卷之填寫結果，北管團體對於自我身分之認定，有84%為業餘子弟，亦即不以遶境出陣或廟會排場籌措曲館經費之意，實際上，子弟曲館的出門，往往都是自掏腰包之負收入情況，因此民間才會流傳以「憨子弟」一詞稱呼這些出錢又出力的曲館子弟；反之，職業團之職業樂手，則以此謀生。</p>
<table>
<tbody>
  <tr style="vertical-align: top;">
<td width="161">
<p>表7：職業/業餘北管團體統計</p>
<table rules="all" border="1" style="border: 1px solid" cellpadding="5">
<tbody>
<tr>
<td width="73">
<p>身分</p>
</td>
<td width="57">
<p>數量</p>
</td>
</tr>
<tr>
<td width="73">
<p>職業</p>
</td>
<td width="57">
<p>4</p>
</td>
</tr>
<tr>
<td width="73">
<p>業餘</p>
</td>
<td width="57">
<p>38</p>
</td>
</tr>
<tr>
<td width="73">
<p>未填寫</p>
</td>
<td width="57">
<p>3</p>
</td>
</tr>
<tr>
<td width="73">
<p>小計</p>
</td>
<td width="57">
<p>45</p>
</td>
</tr>
</tbody>
</table>
</td>

<td v-if="!isMobile" class="tableCenter">
  <img class="img60" src="./../../../assets/ob17/13.jpg" alt="" />
<p>圖13：職業/業餘北管團體比例</p>
</td>
</tr>
<tr v-if="isMobile">
  <td  class="tableCenter">
  <img class="img60" src="./../../../assets/ob17/13.jpg" alt="" />

<p>圖13：職業/業餘北管團體比例</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2022年的活動場次部分，44%之團體年度活動僅1-10場，另有六成團體今年度演出100場以上。活動方式部分，本問卷共分為同好切磋（拜館交流、整絃、排場）、民間傳統廟會及祭典、音樂廳演出、教學與推廣研習、商業演出及其他六類，其中的商業演出係指民間邀約之營利性演出。而根據問卷統計結果，北管團體中，以民間傳統廟會及祭典為主要活動類型，共有41個團體有此活動；其次則為同好切磋、教學與推廣研習，各有十餘個團體有此活動，此統計數字也符合筆者全年度觀察臺灣北管音樂生態之所見。</p>
<table>
<tbody>
  <tr style="vertical-align: top;">
<td width="161">
<p>表8：北管團體年度活動場次統計</p>
<table rules="all" border="1" style="border: 1px solid" cellpadding="5" >
<tbody>
<tr>
<td width="87">
<p>活動場次</p>
</td>
<td width="57">
<p>數量</p>
</td>
</tr>
<tr>
<td width="87">
<p>1-10場</p>
</td>
<td width="57">
<p>20</p>
</td>
</tr>
<tr>
<td width="87">
<p>11-20場</p>
</td>
<td width="57">
<p>5</p>
</td>
</tr>
<tr>
<td width="87">
<p>21-50場</p>
</td>
<td width="57">
<p>7</p>
</td>
</tr>
<tr>
<td width="87">
<p>51-100場</p>
</td>
<td width="57">
<p>3</p>
</td>
</tr>
<tr>
<td width="87">
<p>101-200場</p>
</td>
<td width="57">
<p>1</p>
</td>
</tr>
<tr>
<td width="87">
<p>200場以上</p>
</td>
<td width="57">
<p>2</p>
</td>
</tr>
<tr>
<td width="87">
<p>未填寫</p>
</td>
<td width="57">
<p>7</p>
</td>
</tr>
<tr>
<td width="87">
<p>小計</p>
</td>
<td width="57">
<p>45</p>
</td>
</tr>
</tbody>
</table>
</td>

<td v-if="!isMobile" class="tableCenter">
  <img class="img60" src="./../../../assets/ob17/14.jpg" alt="" />
<p>圖14：北管團體年度活動場次佔比</p>
</td>
</tr>
<tr v-if="isMobile">
  <td  class="tableCenter">
  <img class="img60" src="./../../../assets/ob17/14.jpg" alt="" />

<p>圖14：北管團體年度活動場次佔比</p>
</td>
</tr>
</tbody>
</table>
<p></p>
<table cellpadding="5">
  <tbody>
    <tr>
      <td class="tableCenter">
        <img class="img55" src="./../../../assets/ob17/15.jpeg" alt="" />
      </td>
    </tr>
    <tr>
      <td class="tableCenter">
        <p style="width:50%;margin:0 auto;" class="tableCenter">圖15：北管團體活動類型統計</p>
      </td>
    </tr>
  </tbody>
</table>
<p></p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;團體自填之活動概況部分，多為簡述排練情形之記錄。根據統計，北管團體以一週二次的頻率為最多，一週三次與一週一次者次之。下圖顯示在北管團體中，逾七成之團體，皆維持每週固定團練。少部分無團練者，或有因疫情因素，或因噪音、排練場地等問題而暫時停歇。</p>
<table cellpadding="5">
  <tbody>
    <tr>
      <td class="tableCenter">
        <img class="img55" src="./../../../assets/ob17/16.jpeg" alt="" />
      </td>
    </tr>
    <tr>
      <td class="tableCenter">
        <p style="width:50%;margin:0 auto;" class="tableCenter">圖16：北管團體練習頻率統計</p>
      </td>
    </tr>
  </tbody>
</table>
<p></p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;練習內容部分，團體多以牌子、戲曲為主要練習內容，其中的戲曲練習部分，以練習扮仙戲劇目為主，僅少部分團體因聘請老師上課，而有不同的戲齣之學習與傳承。</p>
<table cellpadding="5">
  <tbody>
    <tr>
      <td class="tableCenter">
        <img class="img55" src="./../../../assets/ob17/17.jpeg" alt="" />
      </td>
    </tr>
    <tr>
      <td class="tableCenter">
        <p style="width:50%;margin:0 auto;" class="tableCenter">圖17：北管團體練習內容統計</p>
      </td>
    </tr>
  </tbody>
</table>
<p></p>
<h3>陸、人數規模及人力結構</h3>
<strong>一、人力結構</strong>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;由於此部分問題較為繁雜，共分為有/無專職人員、以及男/女比、職稱、年齡分布等延伸問題，所收問卷中對於此部分之回答率較低，部分團體之填寫情況也與筆者實際田野觀察了解情況差距有所差距。</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;首先，北管團體中有專職人員者，共有11團，其餘30團無專職人員，另有4團未填寫，作答率91%。此部分內容應著重有專職人員的團體。然而，根據問卷回覆情形，僅有6團完整回覆以上問題，另5團為部分回覆，完成率僅54%，因此，本文此部分僅統計回應之總數。如下方橫條圖所示，北管專職人員之男女性別比例以男性居多，佔總數65%。就年齡分布而言，以19-20歲為最多，60-69歲次之，70歲以上則少有專職人員。</p>
<table>
<tbody>
  <tr style="vertical-align: top;">
<td width="161">
<p>表9：北管團體有/無專職人員統計</p>
<table rules="all" border="1" style="border: 1px solid" cellpadding="5" >
<tbody>
<tr>
<td width="87">
<p>專職人員</p>
</td>
<td width="57">
<p>數量</p>
</td>
</tr>
<tr>
<td width="87">
<p>有</p>
</td>
<td width="57">
<p>11</p>
</td>
</tr>
<tr>
<td width="87">
<p>無</p>
</td>
<td width="57">
<p>30</p>
</td>
</tr>
<tr>
<td width="87">
<p>未填寫</p>
</td>
<td width="57">
<p>4</p>
</td>
</tr>
<tr>
<td width="87">
<p>小計</p>
</td>
<td width="57">
<p>45</p>
</td>
</tr>
</tbody>
</table>
</td>

<td  v-if="!isMobile" class="tableCenter">
  <img class="img60" src="./../../../assets/ob17/18.jpg" alt="" />
<p>圖18：北管團體有/無專職人員統計比例</p>
</td>
</tr>
<tr v-if="isMobile">
  <td  class="tableCenter">
  <img class="img60" src="./../../../assets/ob17/18.jpg" alt="" />

<p>圖18：北管團體有/無專職人員統計比例</p>
</td>
</tr>
</tbody>
</table>
<table cellpadding="5">
  <tbody>
    <tr>
      <td class="tableCenter">
        <img class="img55" src="./../../../assets/ob17/19.jpeg" alt="" />
      </td>
    </tr>
    <tr>
      <td class="tableCenter">
        <p style="width:50%;margin:0 auto;" class="tableCenter">圖19：北管團體專職人員之性別與年齡分布統計</p>
      </td>
    </tr>
  </tbody>
</table>
<p></p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在業餘或兼職人員部分，前述有專職人員的11團中，有6團同時仍有兼職人員，佔比54%。此部分問題同樣有男/女比、職稱、年齡分布等延伸問題，完整回覆率僅69%。</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;如下方橫條圖所示，北管業餘或兼職人員之總數遠高於專職人員，性別比例部分，仍以男性居多，佔總數60%。就年齡分布而言，以50-59、60-69歲兩個區間之習樂人口最多，30-39歲次之；值得注意的是在業餘人口中，18歲以下以及80歲以上之習樂者亦有相當數量。</p>
<table cellpadding="5">
  <tbody>
    <tr>
      <td class="tableCenter">
        <img class="img55" src="./../../../assets/ob17/20.jpeg" alt="" />
      </td>
    </tr>
    <tr>
      <td class="tableCenter">
        <p style="width:50%;margin:0 auto;" class="tableCenter">圖20：北管團體業餘或兼職人員之性別與年齡分布統計</p>
      </td>
    </tr>
  </tbody>
</table>
<p></p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;綜上所述，北管團體無論職業或業餘人員，皆以男性居多，年齡分布則多落在30-69歲之間，由此顯示北管音樂之習樂人口，仍以青壯年為主。</p>
<table cellpadding="5">
  <tbody>
    <tr>
      <td class="tableCenter">
        <img class="img55" src="./../../../assets/ob17/21.jpeg" alt="" />
      </td>
    </tr>
    <tr>
      <td class="tableCenter">
        <p style="width:50%;margin:0 auto;" class="tableCenter">圖21：北管團體專職/業餘人員之性別與年齡總計</p>
      </td>
    </tr>
  </tbody>
</table>
<p></p>
<strong>二、人力來源</strong>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;此部分再一次讓團體勾選有無專職人員，興許部分團體認為方才已回答過，因此這部分勾選有專職人員的團體僅有3團、無專職人員者25團，其餘團體皆未回覆，故回覆率僅62%。而團體之人力來源，在專職或兼職兩部分，皆下設家族成員、相關科系學生、他團轉入、推廣研習活動參與者、2022招募新團員與其他等六類。此部分之回答相對較零散，故筆者合併統計如下。</p>
<table cellpadding="5">
  <tbody>
    <tr>
      <td class="tableCenter">
        <img class="img55" src="./../../../assets/ob17/22.jpeg" alt="" />
      </td>
    </tr>
    <tr>
      <td class="tableCenter">
        <p style="width:50%;margin:0 auto;" class="tableCenter">圖22：北管團體專職或業餘人員之來源統計</p>
      </td>
    </tr>
  </tbody>
</table>
<p></p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;上圖所指為人力來源中，有來自該類別的團體總數，直觀來看，以家族成員居多，2022年有招募新團員的曲館數量次之，部分填寫其他一類者，多指既有團員、鄰居等無法歸入表單各類別一類。若再從各團體回報之人力總數來看，專職人員以家族成員居多，兼職或業餘人員以推廣研習活動參與者之數量最多，佔總業餘習樂人數的41%，其他一類的既有館員次之，佔比15%。另外，2022年北管團體招募新團員總數有88人，為本次問卷調查相當值得欣喜之發現。</p>
<table>
<tbody>
  <tr style="vertical-align: top;">
<td width="189">
<p>表10：北管團體專職/業餘人力來源統計（人數）</p>
<table rules="all" border="1" style="border: 1px solid" cellpadding="5" >
<tbody>
<tr>
<td width="87">
<p>人力來源</p>
</td>
<td width="45">
<p>專職</p>
</td>
<td width="45">
<p>業餘</p>
</td>
</tr>
<tr>
<td width="87">
<p>家族成員</p>
</td>
<td width="45">
<p>17</p>
</td>
<td width="45">
<p>100</p>
</td>
</tr>
<tr>
<td width="87">
<p>相關科系學生</p>
</td>
<td width="45">
<p>5</p>
</td>
<td width="45">
<p>20</p>
</td>
</tr>
<tr>
<td width="87">
<p>他團轉入</p>
</td>
<td width="45">
<p>0</p>
</td>
<td width="45">
<p>41</p>
</td>
</tr>
<tr>
<td width="87">
<p>推廣研習活動參與者</p>
</td>
<td width="45">
<p>8</p>
</td>
<td width="45">
<p>269</p>
</td>
</tr>
<tr>
<td width="87">
<p>2022招募新團員</p>
</td>
<td width="45">
<p>10</p>
</td>
<td width="45">
<p>88</p>
</td>
</tr>
<tr>
<td width="87">
<p>其他</p>
</td>
<td width="45">
<p>0</p>
</td>
<td width="45">
<p>126</p>
</td>
</tr>
</tbody>
</table>
</td>
<td v-if="!isMobile" class="tableCenter">
  <img class="img55" src="./../../../assets/ob17/23.jpeg" alt="" />
<p>圖23：北管團體專職/業餘人力來源總計</p>
</td>
</tr>
<tr v-if="isMobile">
  <td  class="tableCenter">
  <img class="img60" src="./../../../assets/ob17/23.jpeg" alt="" />

<p>圖23：北管團體專職/業餘人力來源總計</p>
</td>
</tr>
</tbody>
</table>
<h3>柒、當前發展</h3>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;最後一部分為針對北管團體的當前發展情況調查，問卷共分為傳播方式、推廣研習活動之效益及面臨困境三方面。此部分為複選題，每個團體至多可勾選三項，統計結果如下。</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;第一，傳播方式部分，有效回答42份，根據統計結果，北管團體之傳播，以社群媒體與口耳相傳為主，遠遠超過節慶活動主辦單位宣傳以及海報、官方網站等傳播管道。此題之統計結果，也恰恰呼應了前文提及北管團體有Facebook粉絲專頁者佔比極高一事。</p>
<table cellpadding="5">
  <tbody>
    <tr>
      <td class="tableCenter">
        <img class="img70" src="./../../../assets/ob17/24.jpeg" alt="" />
      </td>
    </tr>
    <tr>
      <td class="tableCenter">
        <p style="width:50%;margin:0 auto;" class="tableCenter">圖24：北管團體傳播方式統計</p>
      </td>
    </tr>
  </tbody>
</table>
<p></p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;其次，推廣研習活動之效益部分，上一章述及北管人力來源時，已見有為數可觀的推廣研習活動參與者參與其中，而對於這些活動參與者對北管音樂之助益一題，此部分共收到40份回覆。根據統計結果顯示，北管團體認為推廣研習活動首重應為技藝傳承與藝術推廣，其次才是提昇民眾意願與吸引人才投入等促進北管習藝人口之助益。</p>
<table cellpadding="5">
  <tbody>
    <tr>
      <td class="tableCenter">
        <img class="img70" src="./../../../assets/ob17/25.jpeg" alt="" />
      </td>
    </tr>
    <tr>
      <td class="tableCenter">
        <p style="width:50%;margin:0 auto;" class="tableCenter">圖25：北管團體推廣研習活動效益統計</p>
      </td>
    </tr>
  </tbody>
</table>
<p></p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;最後，本問卷邀請北管團體勾選自覺面臨之困境，共計收到43份回覆。從研究結果顯示，逾半數的團體對於人才斷層、資金取得不易二件事最為擔憂，其次則為國內民眾參與意願低、政府行政資源有限、傳統藝術價值傳承困難等議題。簡言之，此部分之回應結果，筆者認為與前面二題北管團體所關心之議題，顯得相當一致，主要在於技藝、人員、經費三部分。</p>
<table cellpadding="5">
  <tbody>
    <tr>
      <td class="tableCenter">
        <img class="img70" src="./../../../assets/ob17/26.jpeg" alt="" />
      </td>
    </tr>
    <tr>
      <td class="tableCenter">
        <p style="width:50%;margin:0 auto;" class="tableCenter">圖26：北管團體面臨困境統計</p>
      </td>
    </tr>
  </tbody>
</table>
<p></p>
<h3>捌、結語</h3>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;通過本次問卷調查分析，筆者得以從大數據角度，深入了解北管團體之各項情況；惟問卷內容部分涉及團體隱私，為尊重團體意願，由團體自行決定是否完整填寫。在個別統計之外，筆者亦彙整問卷各題之回覆情況。由下表可知，北管團體對於問卷各題目之反應，仍以提供基本資料與反應當前面臨問題有較高的填寫意願，在收支情況與人力結構部分，則有程度不一的回應情況。</p>
<p></p>
<span>表11：問卷回覆情形統計</span>
<table rules="all" border="1" style="border: 1px solid" cellpadding="5" >
<tbody>
<tr>
<td width="66">
<p>分項</p>
</td>
<td width="45">
<p>No.</p>
</td>
<td width="184">
<p>主題</p>
</td>
<td width="76">
<p>完整回應</p>
</td>
<td width="68">
<p>部分回應</p>
</td>
<td width="57">
<p>未回應</p>
</td>
<td width="97">
<p>完整回應率</p>
</td>
</tr>
<tr>
<td rowspan="8" width="66">
<p>一、 基本概況</p>
</td>
<td width="45">
<p>1</p>
</td>
<td width="184">
<p>團體名稱</p>
</td>
<td width="76">
<p>45</p>
</td>
<td width="68">
<p>0</p>
</td>
<td width="57">
<p>0</p>
</td>
<td width="97">
<p>100%</p>
</td>
</tr>
<tr>
<td width="45">
<p>2</p>
</td>
<td width="184">
<p>負責人</p>
</td>
<td width="76">
<p>45</p>
</td>
<td width="68">
<p>0</p>
</td>
<td width="57">
<p>0</p>
</td>
<td width="97">
<p>100%</p>
</td>
</tr>
<tr>
<td width="45">
<p>3</p>
</td>
<td width="184">
<p>地址</p>
</td>
<td width="76">
<p>44</p>
</td>
<td width="68">
<p>0</p>
</td>
<td width="57">
<p>1</p>
</td>
<td width="97">
<p>98%</p>
</td>
</tr>
<tr>
<td width="45">
<p>4</p>
</td>
<td width="184">
<p>電話</p>
</td>
<td width="76">
<p>43</p>
</td>
<td width="68">
<p>0</p>
</td>
<td width="57">
<p>2</p>
</td>
<td width="97">
<p>96%</p>
</td>
</tr>
<tr>
<td width="45">
<p>5</p>
</td>
<td width="184">
<p>其他聯絡方式</p>
</td>
<td width="76">
<p>39</p>
</td>
<td width="68">
<p>0</p>
</td>
<td width="57">
<p>6</p>
</td>
<td width="97">
<p>87%</p>
</td>
</tr>
<tr>
<td width="45">
<p>6</p>
</td>
<td width="184">
<p>成立時間</p>
</td>
<td width="76">
<p>38</p>
</td>
<td width="68">
<p>0</p>
</td>
<td width="57">
<p>7</p>
</td>
<td width="97">
<p>84%</p>
</td>
</tr>
<tr>
<td width="45">
<p>7</p>
</td>
<td width="184">
<p>立案情形</p>
</td>
<td width="76">
<p>42</p>
</td>
<td width="68">
<p>0</p>
</td>
<td width="57">
<p>3</p>
</td>
<td width="97">
<p>93%</p>
</td>
</tr>
<tr>
<td width="45">
<p>8</p>
</td>
<td width="184">
<p>團隊榮譽</p>
</td>
<td width="76">
<p>24</p>
</td>
<td width="68">
<p>0</p>
</td>
<td width="57">
<p>21</p>
</td>
<td width="97">
<p>53%</p>
</td>
</tr>
<tr>
<td rowspan="4" width="66">
<p>二、活動與收支情況</p>
</td>
<td width="45">
<p>9</p>
</td>
<td width="184">
<p>2022年活動方式</p>
</td>
<td width="76">
<p>40</p>
</td>
<td width="68">
<p>3</p>
</td>
<td width="57">
<p>2</p>
</td>
<td width="97">
<p>89%</p>
</td>
</tr>
<tr>
<td width="45">
<p>10</p>
</td>
<td width="184">
<p>收入狀況</p>
</td>
<td width="76">
<p>38</p>
</td>
<td width="68">
<p>3</p>
</td>
<td width="57">
<p>4</p>
</td>
<td width="97">
<p>84%</p>
</td>
</tr>
<tr>
<td width="45">
<p>11</p>
</td>
<td width="184">
<p>支出狀況</p>
</td>
<td width="76">
<p>38</p>
</td>
<td width="68">
<p>3</p>
</td>
<td width="57">
<p>4</p>
</td>
<td width="97">
<p>84%</p>
</td>
</tr>
<tr>
<td width="45">
<p>12</p>
</td>
<td width="184">
<p>活動概況</p>
</td>
<td width="76">
<p>41</p>
</td>
<td width="68">
<p>0</p>
</td>
<td width="57">
<p>4</p>
</td>
<td width="97">
<p>91%</p>
</td>
</tr>
<tr>
<td rowspan="4" width="66">
<p>三、人力結構</p>
</td>
<td width="45">
<p>13</p>
</td>
<td width="184">
<p>人力結構（專職）</p>
</td>
<td width="76">
<p>36</p>
</td>
<td width="68">
<p>7</p>
</td>
<td width="57">
<p>2</p>
</td>
<td width="97">
<p>80%</p>
</td>
</tr>
<tr>
<td width="45">
<p>14</p>
</td>
<td width="184">
<p>人力結構（業餘或兼職）</p>
</td>
<td width="76">
<p>31</p>
</td>
<td width="68">
<p>14</p>
</td>
<td width="57">
<p>0</p>
</td>
<td width="97">
<p>69%</p>
</td>
</tr>
<tr>
<td width="45">
<p>15</p>
</td>
<td width="184">
<p>人力來源（專職）</p>
</td>
<td width="76">
<p>28</p>
</td>
<td width="68">
<p>4</p>
</td>
<td width="57">
<p>13</p>
</td>
<td width="97">
<p>62%</p>
</td>
</tr>
<tr>
<td width="45">
<p>16</p>
</td>
<td width="184">
<p>人力來源（業餘或兼職）</p>
</td>
<td width="76">
<p>33</p>
</td>
<td width="68">
<p>3</p>
</td>
<td width="57">
<p>9</p>
</td>
<td width="97">
<p>73%</p>
</td>
</tr>
<tr>
<td rowspan="3" width="66">
<p>四、當前發展</p>
</td>
<td width="45">
<p>17</p>
</td>
<td width="184">
<p>傳播方式（可複選）</p>
</td>
<td width="76">
<p>42</p>
</td>
<td width="68">
<p>0</p>
</td>
<td width="57">
<p>3</p>
</td>
<td width="97">
<p>93%</p>
</td>
</tr>
<tr>
<td width="45">
<p>18</p>
</td>
<td width="184">
<p>推廣研習活動之效益（複選）</p>
</td>
<td width="76">
<p>40</p>
</td>
<td width="68">
<p>0</p>
</td>
<td width="57">
<p>5</p>
</td>
<td width="97">
<p>89%</p>
</td>
</tr>
<tr>
<td width="45">
<p>19</p>
</td>
<td width="184">
<p>面臨困境（複選）</p>
</td>
<td width="76">
<p>42</p>
</td>
<td width="68">
<p>0</p>
</td>
<td width="57">
<p>3</p>
</td>
<td width="97">
<p>93%</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;為協助日後此類問卷之優化，筆者將問卷聯繫過程中，北管團體對於本次調查問卷之反饋意見，一併收錄於此，供中心及各界參考，盼能促進各方之理解與溝通。在聯繫過程中，婉拒填寫之團體，其原因大致係因時間精力有限，無法協助填寫，或是此類型調查先前已做過，無意願再次回應，並希望公部門間能橫向整合及流通資訊，以避免團體重複受訪。在完成問卷填寫之團體反饋意見中，部分團體不約而同向筆者反應此問卷與北管子弟生態有較大差距，許多問題無從下筆，尤其對於調查團體收支與人力結構二部分有所遲疑；其餘還有提及日後或可簡化及數位化問卷，以提昇問卷回收情況等建議，謹陳於此。</p>
<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;最後，由衷感謝本次問卷調查分析之契機，筆者得以在「2022臺灣音樂年鑑編輯計畫」的執行觀察分析之餘，從量化研究角度管窺北管團體之現狀發展情況。然而，北管團體眾多，填寫者僅其中一部分，因此本文需再次重申，此次分析結果僅能反應2022年度協助填寫問卷團體之部分情況，並無法以此涵蓋整個北管音樂大環境，惟仍希冀問卷之完成，能作為傳藝中心及相關部門日後施政、補助之參考。</p>
<hr />
<p></p>
<small class="mobileSmall" style="text-align:left;word-break: break-all;">

<sup>1</sup>本次調查報告之完成，由衷感謝所有提供意見及協助填寫之北管團體與樂友，以及鄭湘蓁、姜妤璇、巫欣諭三位研究生協助問卷的寄送與整理事宜，本人銘感五內。<br>
<sup>2</sup>本文統計所採之區域劃分，北部指基隆、臺北、新北、桃園與新竹，中部指苗栗、臺中、彰化、南投、雲林，南部指嘉義以南至屏東，東部指宜蘭、花蓮、臺東等縣市。<br>
<sup>3</sup>特別說明，由於本問卷之收支情況，乃採用金額區間勾選方式，因此，此處所指之「呈現盈餘」係指收入狀況之勾選欄位大於支出狀況之所選欄位，例如A團體之年收入勾選50-75萬區間、年支出勾選25-50萬區間，即代表A團之年收支情況為盈餘狀態；反之亦然。<br>
</small>
  </div>
</template>

<script>

export default {
  computed: {
    isMobile() {
      return document.body.clientWidth <= 576
    },
  },
};
</script>